export const PENDING = 'PENDING'
export const SUCCESS = 'SUCCESS'
export const FAILURE = 'FAILURE'

export const NO_VERSION = 'no-version'
export const TARGET_BLANK = '_blank'
export const CHECK_LOCK_TIMEOUT = 5000
export const LOGOUT_UI_TIMEOUT = 300
export const PROCESS_RECORD_EVENT = 1
export const PROCESS_SYSTEM = 2
export const PROCESS_FUNCTION_API = 3
export const PROCESS_FORM_SAVE = 4
export const PROCESS_QUEUE_CALLBACK = 5
export const ACTION_CREATE_RECORD = 1
export const ACTION_UPDATE_RECORD = 2
export const ACTION_JAVASCRIPT = 3
export const ACTION_PROCESS = 4
export const ACTION_REDIRECT = 5
export const ACTION_DELETE = 6
export const ACTION_NOTIFICATION = 7
export const ACTION_WORKFLOWSTART = 8
export const ACTION_WORKFLOWSTEP = 9
export const ACTION_STATUSSET = 10
export const ACTION_ASSIGN_FORM_THEN_REDIRECT = 11
export const ACTION_EMAIL = 12
export const ACTION_USERLOGIN = 13
export const ACTION_USERLOGOUT = 14
export const ACTION_ETL = 15
export const ACTION_CREATEFORM = 16
export const ACTION_UPDATEFORM = 17
export const ACTION_REMOVE = 18
export const ACTION_BULKSABLONGENERATE = 19
export const ACTION_DOCSTOZIP = 20
export const ACTION_WORKFLOWCLOSE = 21
export const ACTIONS_BY_PROCESS_TYPE = {
  [PROCESS_RECORD_EVENT]: [
    ACTION_CREATE_RECORD,
    ACTION_UPDATE_RECORD,
    ACTION_JAVASCRIPT,
    ACTION_PROCESS,
    ACTION_REDIRECT,
    ACTION_NOTIFICATION,
    ACTION_WORKFLOWSTART,
    ACTION_WORKFLOWSTEP,
    ACTION_STATUSSET,
    ACTION_ASSIGN_FORM_THEN_REDIRECT,
    ACTION_EMAIL,
    ACTION_ETL,
    ACTION_DOCSTOZIP,
    ACTION_WORKFLOWCLOSE,
  ],
  [PROCESS_SYSTEM]: [
    ACTION_CREATE_RECORD,
    ACTION_UPDATE_RECORD,
    ACTION_JAVASCRIPT,
    ACTION_PROCESS,
    ACTION_REDIRECT,
    ACTION_NOTIFICATION,
    ACTION_EMAIL,
    ACTION_USERLOGIN,
    ACTION_USERLOGOUT,
    ACTION_ETL,
    ACTION_DOCSTOZIP,
  ],
  [PROCESS_FUNCTION_API]: [
    ACTION_CREATE_RECORD,
    ACTION_UPDATE_RECORD,
    ACTION_JAVASCRIPT,
    ACTION_PROCESS,
    ACTION_REDIRECT,
    ACTION_DELETE,
    ACTION_NOTIFICATION,
    ACTION_WORKFLOWSTART,
    ACTION_WORKFLOWSTEP,
    ACTION_EMAIL,
    ACTION_ETL,
    ACTION_REMOVE,
    ACTION_BULKSABLONGENERATE,
    ACTION_DOCSTOZIP,
  ],
  [PROCESS_FORM_SAVE]: [
    ACTION_CREATE_RECORD,
    ACTION_UPDATE_RECORD,
    ACTION_JAVASCRIPT,
    ACTION_PROCESS,
    ACTION_REDIRECT,
    ACTION_NOTIFICATION,
    ACTION_EMAIL,
    ACTION_ETL,
    ACTION_CREATEFORM,
    ACTION_UPDATEFORM,
    ACTION_DOCSTOZIP,
  ],
  [PROCESS_QUEUE_CALLBACK]: [
    ACTION_CREATE_RECORD,
    ACTION_UPDATE_RECORD,
    ACTION_JAVASCRIPT,
    ACTION_PROCESS,
    ACTION_REDIRECT,
    ACTION_NOTIFICATION,
    ACTION_EMAIL,
    ACTION_ETL,
    ACTION_CREATEFORM,
    ACTION_UPDATEFORM,
    ACTION_DOCSTOZIP,
  ],
}
export const PROCESS_MODAL_ID = 'process-modal'
export const CRITERIA_MODAL_ID = 'criteria-modal'
export const ACTION_MODAL_ID = 'action-modal'
export const EXPRESSION_TYPES = {
  TYPE_OPTIONS: 'typeOptionsExp',
  VALUE: 'valueExp',
  LABEL: 'labelExp',
  READ_ONLY: 'readOnlyExp',
  HIDDEN: 'hiddenExp',
  LIST: 'listExp',
  FILTER: 'filterExp',
  REQUIRED: 'requiredExp',
  FORMATTED_VALUE: 'formattedValue',
  PROPERTY_OVERRIDE: 'propertyOverride',
  SAVE_EXP: 'saveExpression',
}
export const FIELD_PROPS = {
  HIDDEN: 'hidden',
  READ_ONLY: 'readOnly',
  TYPE_OPTIONS: 'typeOptions',
  VALUE: 'value',
  FORMATTED_VALUE: 'formattedValue',
  LIST: 'list',
  LABEL: 'label',
  REQUIRED: 'required',
  VALIDATIONS: 'validations',
  FORMATS: 'formats',
  ITEMS: 'items',
  NAME: 'name',
}
export const GET_DATA_FIELD_PROPS = {
  HIDDEN: 'HIDDEN',
  READ_ONLY: 'READ_ONLY',
  VALUE: 'VALUE',
  LIST: 'LIST',
  AUTOCOMPLETE: 'AUTOCOMPLETE',
  LABEL: 'LABEL',
  REQUIRED: 'REQUIRED',
  FORMATTED_VALUE: 'FORMATTED_VALUE',
  ITEMS: 'ITEMS',
}
export const FORMATTED_FIELD_TYPES = ['multiselect', 'dropdownlist', 'sqlchoosen', 'radiobuttonlist']
export const FIELD_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  NUMBER: 'number',
  PASSWORD: 'password',
  LABEL: 'label',
  NOTE: 'note',
  TEXTAREA: 'textarea',
  RICH_TEXT: 'richtext',
  EXPRESSION_EDITOR: 'expressioneditor',
  COMMENT: 'comment',
  DATETIME: 'datetime-local',
  DATETIME_OLD: 'datetime',
  DATE: 'date',
  DATE_INTERVAL: 'date_interval',
  DATETIME_INTERVAL: 'datetime_interval',
  TIME_INTERVAL: 'time_interval',
  TIME: 'time',
  CHECKBOX: 'checkbox',
  CHECKBOX_LIST: 'checkboxlist',
  RADIO_BUTTON_LIST: 'radiobuttonlist',
  SQL_CHOSEN: 'sqlchoosen',
  DROPDOWN: 'dropdownlist',
  MULTISELECT: 'multiselect',
  SUB_FORM: 'subform',
  SUB_FORM_FIELD: 'subFormField',
  W_PAINT: 'wpaint',
  GPS: 'gps',
  SIGNATURE: 'signature',
  CAMERAS: 'cameras',
  SLIDER: 'slider',
  MAP: 'map',
  LINK: 'link',
  RATING: 'rating',
  CAPTCHA: 'captcha',
  STATUS: 'status',
  BOOLEAN: 'boolean',
  LIST: 'list',
  COMPUTED_LABEL: 'computedLabel',
  DYNAMIC_WRAPPER: 'dynamic-wrapper',
  INFO: 'info',
} as const

export const SUB_FORM_FIELD_PROPS = [
  'hidden',
  'readOnly',
  'label',
  'required',
  'value',
  'formattedValue',
  'object',
  'name',
  'id',
]
export const FIELD_REQUIRED_LEVELS = {
  NONE: '0',
  WARNING: '1',
  ERROR: '2',
}
export const AI_ASSISTANTS = {
  FORM_CREATOR: 'FormCreator',
  EXPRESSION_HELPER: 'ExpressionHelper',
  PROCESS_HELPER: 'ProcessHelper',
  PROCESS_CODE_REVIEWER: 'ProcessCodeReviewer',
  EXPRESSION_CODE_REVIEWER: 'ExpressionCodeReviewer',
  EXPRESSION_CODE_REVIEWER_TEST: 'ExpressionCodeReviewerTest',
  DEFAULT_CODE_WRITER: 'DefaultCodeWriter',
  DEFAULT_CODE_REVIEWER: 'DefaultCodeReviewer',
  DEFAULT_CHAT: 'DefaultChat',
}
export const EDITOR_MODES = {
  VUE: 'text/x-vue',
  HTML: 'text/html',
  HTML_MIXED: 'htmlmixed',
  JAVASCRIPT: 'text/javascript',
  CSS: 'css',
  SQL: 'sql',
}
export const MAIN_FORM_NAME = 'MAIN_FORM'
export const SUBMIT_TYPES = {
  CREATE: 'create',
  UPDATE: 'update',
}
export const CALENDAR_VIEWS = {
  WEEK: 'agendaWeek',
  MONTH: 'month',
}
export const DESIGNER_TOOLS = {
  PALETTE: 'palette',
  ENUM_MANAGER: 'enum-manager',
  FIELD_IMPORTER: 'field-importer',
  MANAGER_MODE: 'manager-mode',
  FILTER_BUILDER: 'filter-builder',
  GUI_SETTINGS: 'gui-settings',
  VERIFICATIONS: 'verifications',
  GENERATE_FIELDS: 'generate-fields',
  DESIGNER_FINDER: 'designer-finder',
}
export const BOOLEAN_STRINGS = ['true', '1', 'false', '0']

export const SIMPLEPAY_FINAL_STATUSES = ['FINISHED', 'CANCELLED', 'TIMEOUT', 'NOTAUTHORIZED']

export const BOOLEAN_FIELD_PROPERTIES = [FIELD_PROPS.HIDDEN, FIELD_PROPS.READ_ONLY]

export const CREATOR_ICON_PREFIX = 'material-symbols:'

export const ENUM_MANAGER_DROPDOWN_FIELD_NAME_PREFIX = 'ID_'
export const ENUM_MANAGER_DROPDOWN_FIELD_NAME = 'NAME'
export const ENUM_MANAGER_DROPDOWN_FIELD_LOCALIZATION_KEY = 'form_designer_generated_enum_name'
export const ENUM_MANAGER_CONFIRMATION_MESSAGE = 'form_designer_enum_generate_confirmation_message'
export const ENUM_MANAGER_RESPONSE_STATUS_TYPES = {
  FAILED: 'failed',
  SUCCESS: 'success',
}

export const MONGO_COLLECTIONS = {
  FORM_DATA_VERSION: 'FormDataVersion',
}

export const SUBMIT_ROOT_TYPES = { CREATE: 'create', UPDATE: 'update' }
